import type { SVGProps } from "react";
import React from "react";
export function CameraSVG(props: SVGProps<SVGSVGElement>) {
  return (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={29}
    fill="none"
    {...props}
  >
    <path
      fill="#0095A5"
      d="M20.439 14a6.439 6.439 0 1 1 0 12.878 6.439 6.439 0 0 1 0-12.878Zm0 2.34-.105.01a.586.586 0 0 0-.47.47l-.01.106v2.927h-2.93l-.105.01a.586.586 0 0 0-.47.47l-.01.106.01.105a.586.586 0 0 0 .47.47l.105.01h2.93v2.931l.01.106a.586.586 0 0 0 .471.47l.105.01.105-.01a.586.586 0 0 0 .471-.47l.01-.106v-2.931h2.93l.106-.01a.586.586 0 0 0 .47-.47l.01-.105-.01-.105a.586.586 0 0 0-.47-.47l-.106-.01-2.932-.001v-2.927l-.01-.105a.586.586 0 0 0-.47-.471l-.105-.01ZM16.253 2.882c.934 0 1.799.494 2.272 1.3l.953 1.623h2.424a3.805 3.805 0 0 1 3.805 3.805l.001 5.339c-.52-.5-1.11-.926-1.755-1.262L23.95 9.61a2.049 2.049 0 0 0-2.049-2.049h-2.926a.878.878 0 0 1-.758-.433L17.01 5.07a.878.878 0 0 0-.757-.433h-4.451a.878.878 0 0 0-.673.313l-.075.105-1.281 2.086a.878.878 0 0 1-.749.419H6.098a2.049 2.049 0 0 0-2.05 2.049v11.122c0 1.131.918 2.049 2.05 2.049l7.098-.001c.202.625.482 1.214.83 1.757H6.098a3.805 3.805 0 0 1-3.805-3.805V9.61a3.805 3.805 0 0 1 3.805-3.805h2.435l1.024-1.668a2.634 2.634 0 0 1 2.245-1.255h4.451ZM14 9.317a5.27 5.27 0 0 1 5.014 3.646 7.52 7.52 0 0 0-1.678.526 3.511 3.511 0 0 0-6.848 1.096 3.513 3.513 0 0 0 2.737 3.427 7.55 7.55 0 0 0-.363 1.718A5.27 5.27 0 0 1 14 9.317Z"
    />
  </svg>
  );
}
